import {
  ERROR_NODE,
  REQUEST_NODE,
  RECEIVE_NODE,
  INVALIDATE_FORM,
  REQUEST_FORM,
  RECEIVE_FORM,
  SET_FORM_VALUE
} from './actions'

export function nodes(
  state = {
  },
  action
) {
  switch (action.type) {
    case REQUEST_NODE:
      return Object.assign({}, state, {
        [action.id]: {
          ...state[action.id],
          error: false,
          isFetching: true,
          didInvalidate: false
        }
      })
    case RECEIVE_NODE:
      return Object.assign({}, state, {
        [action.id]: {
          ...state[action.id],
          isFetching: true,
          didInvalidate: false,
          ...action.node
        }
      })
    case ERROR_NODE:
      return Object.assign({}, state, {
        [action.id]: {
          ...state[action.id],
          isFetching: false,
          didInvalidate: false,
          error: true,
          errorValue: action.err
        }
      })
    default:
      return state
  }
}

export function forms(
  state = {
    isFetching: false,
    didInvalidate: false,
    form: {},
    formValues: {}
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_FORM:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_FORM:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_FORM:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        form: action.form,
        formValues: action.formValues,
        lastUpdated: action.receivedAt
      })
    case SET_FORM_VALUE:
      return Object.assign({}, state, {
        formValues: {
          ...state.formValues,
          [action.name]: action.value
        }
      })
    default:
      return state
  }
}
